export default "__VITE_ASSET__BndI6O4O__"